import styled from "@emotion/styled";

export const Button = styled.a`
  height: 40px;
  background-color: #f8f1e8;
  border: 1px solid #efe3d5;
  border-radius: 12px;
  font-size: 16px;
  color: #321e0f;
  align-self: center;
  width: auto;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    background-color: #f2e5d0;
  }
  text-decoration: none;
`;
